import {
  Activation,
  Admin,
  ForgotPassword,
  HumanResources,
  NotFound,
  Partner,
  Recovery,
  TutorPages,
  Vet,
} from 'pages';
import { LoginPage } from 'pages/Auth/Login';
import { PartnerRegistrationPage } from 'pages/Auth/PartnerRegistration';
import { RecoveryPasswordPage } from 'pages/Auth/RecoveryPassword';
import { RequestRecoveryPasswordPage } from 'pages/Auth/RequestRecoveryPassword';
import { TutorRecoveryPasswordPage } from 'pages/Auth/TutorRecoveryPassword';
import { TutorRegistrationPage } from 'pages/Auth/TutorRegistration';
import { DownloadAppPage } from 'pages/DownloadApp';
import { FC } from 'react';
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import { ProtectedRoute } from './ProtectedRoute';
import { SignInRoute } from './SignInRoute';
import { B2B } from 'pages/B2B';

export const Routes: FC = () => {
  return (
    <Router>
      <Switch>
        {/* userRole can be vet, tutor or admin */}
        <SignInRoute exact path="/:userRole">
          <LoginPage />
        </SignInRoute>

        {/* userRole can be vet or partner */}
        <SignInRoute exact path="/:userRole/request-recovery">
          <RequestRecoveryPasswordPage />
        </SignInRoute>

        {/* Token is received as query param ?token=XXXX */}
        <Route path="/tutor/recovery-password">
          <TutorRecoveryPasswordPage />
        </Route>

        {/* Token is received as query param ?token=XXXX */}
        <Route path="/tutor/define-password">
          <TutorRecoveryPasswordPage firstPassword={true} />
        </Route>

        {/* userRole can be admin, vet, rh or partner. Token is received as query param ?token=XXXX */}
        <SignInRoute exact path="/:userRole/recovery-password">
          <RecoveryPasswordPage />
        </SignInRoute>

        {/* userRole can be admin, vet, rh or partner. Token is received as query param ?token=XXXX */}
        <SignInRoute exact path="/:userRole/define-password">
          <RecoveryPasswordPage firstPassword={true} />
        </SignInRoute>

        <SignInRoute exact path="/partner/registration">
          <PartnerRegistrationPage />
        </SignInRoute>

        <SignInRoute exact path="/tutor/registration/:plan">
          <TutorRegistrationPage />
        </SignInRoute>

        <Route path="/forgot-password">
          <ForgotPassword />
        </Route>

        <ProtectedRoute path="/admin/dashboard" allowRole="admin">
          <Admin />
        </ProtectedRoute>

        <ProtectedRoute path="/company" allowRole="company">
          <HumanResources />
        </ProtectedRoute>

        <ProtectedRoute path="/vet/dashboard" allowRole="vet">
          <Vet />
        </ProtectedRoute>

        {/* Partner pages */}
        <ProtectedRoute path="/partner" allowRole="partner">
          <Partner />
        </ProtectedRoute>

        {/* Tutor pages */}
        <ProtectedRoute path="/tutor" allowRole="tutor">
          <TutorPages />
        </ProtectedRoute> 

        <Route path="/recover/:token">
          <Recovery />
        </Route>

        <Route path="/activate/:token">
          <Activation />
        </Route>

        <SignInRoute exact path="/">
          <Redirect to="/vet" />
        </SignInRoute>

        <Route path="/app/download">
          <DownloadAppPage />
        </Route>

        {/* B2B WHITE LABEL ROUTES */}
        <Route path="/b2b/call/:tutorId/:queuePosition/:tutorName/:callCode">
          <B2B />
        </Route>

        {/* B2B WHITE LABEL ROUTES */}
        {/* <Route path="/b2b/call/:tutorId/:queuePosition/:tutorName/:jitsiUrl">
          <B2B />
        </Route> */}

        {/* default */}
        <Route path="*">
          <NotFound />
        </Route>
      </Switch>
    </Router>
  );
};
